
















































import { WithdrawalsParams } from '@/store/interfaces/withdrawals';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'WithdrawalsRefund',
  props: {
    viewModal: {
      required: true,
      type: Boolean,
    },
    refund: {
      required: true,
      type: Object as PropType<WithdrawalsParams>,
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean): void {
        this.$emit('update:viewModal', value);
      },
    },
  },
  methods: {
    close(): void {
      this.syncedViewModal = false;
    },
    confirmRefund(): void {
      this.syncedViewModal = false;
      this.$emit('confirm', true);
    },
  },
});
